
import axios from 'utils/axios';
import {dispatch, store} from 'store';

import {createSlice} from '@reduxjs/toolkit';
import { DashboardYearlyProps } from 'types/props-obj/dashboardYearlyProps';




const initialState: DashboardYearlyProps = {
    apiEndPoint: "dashboard_yearly",
    
    data: [],
  
};

const dashboardyearly = createSlice({
    name: initialState.apiEndPoint,
    initialState,
    reducers: {
       
       

        // GET Items
        setItemsSuccess(state, action) {
            state.data = action.payload;
            
        },

        // ADD Item
      


        setApiEndPoint(state, action) {
            state.apiEndPoint = action.payload;
        },
       
    }
});


export default dashboardyearly.reducer;

function getApiEndPoint(){
    return store.getState().dashboardyearly.apiEndPoint
}

export const { setApiEndPoint } = dashboardyearly.actions;
export function getdashboardyearlyData(params:any={}) {
    return async () => {
        try {
            const response = await axios.get(getApiEndPoint(),{params:params});
            dispatch(dashboardyearly.actions.setItemsSuccess(response.data));
        } catch (error) {
            // dispatch(dashboardyearly.actions.hasError(error));
        }
    };
}

